export const SeccionUbicacion = ({ data }) => {
    const tdStyle = {
        padding: '3px'
    };
    return (
        <>
            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                Datos de Ubicación
            </div>
            <table style={{ width: '98%', borderCollapse: 'collapse', marginTop: '5px' }} role='presentation'>
                <tbody>
                    <tr>
                        <td style={{ ...tdStyle, width: '38%' }}><strong>Domicilio:</strong>&nbsp;{data?.calle}</td>
                        <td style={{ ...tdStyle, width: '32%' }}><strong>Código Postal:</strong>&nbsp;{data?.cp}</td>
                        <td style={{ ...tdStyle, width: '30%' }}><strong>Localidad:</strong>&nbsp;{data?.localidad}</td>
                    </tr>
                    <tr>
                        <td style={{ ...tdStyle }}><strong>Provincia:</strong>&nbsp;{data?.provincia}</td>
                        <td style={{ ...tdStyle }}><strong>País:</strong>&nbsp;Argentina</td>
                        <td style={{ ...tdStyle }}><strong>Teléfono:</strong>&nbsp;{data?.telefonoUbicacion}</td>
                    </tr>
                    <tr>
                        <td style={{ ...tdStyle }} colSpan={3}><strong>Observaciones:</strong>&nbsp;{data?.observaciones}</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}